<script lang="ts">
// import type { Router } from 'vue-router'

import ListTable from '@nuxtDatakodeUtils/components/list/Table.vue'
import i3pSubComponent from '@nuxtDatakodeUtils/components/i3p/I3pSubComponent.vue'

export default {
    name: 'MapPopup',
    components: { ListTable },
    extends: i3pSubComponent,
    props: {
        translationName: { type: String, required: true },
        features: { type: Array, required: false, default: () => ([]) },
    },
    data() {
        return {
            sheet: true,
            columns: [
                { dataKey: 'name', template: [this.textLeft] },
                { dataKey: 'insee', template: [this.textLeft] },
            ],
        }
    },
    watch: {
        features() {
            this.sheet = !!this.features.length
        },
    },
    methods: {
        showPopup() {
            this.sheet = !this.sheet
        },
        clickColumn(event) {
            this.$router.push(`./${event.item.k}`)
        },
    },
}
</script>

<template>
    <v-expand-transition>
        <v-card
            class="py-2 px-4 text-center position-absolute"
            :active="sheet"
            style="bottom:0; z-index:1000"
            :style="{ display: sheet ? 'inherit' : 'none' }"
            width="100%"
        >
            <ListTable
                ref="table"
                density="compact"
                permission-name=""
                :permission-skip="true"
                :translation-name
                :sortable="[]"
                :no-action="true"
                :columns
                :data="features.map(feature => feature.properties)"
            />
            <!-- :click-columns="columns.map(col => col.dataKey)" -->
            <!-- @click-column="clickColumn($event)" -->
        </v-card>
    </v-expand-transition>
</template>

<style>
/* #map-declarations-tooltip .v-bottom-navigation__content {
    display: block !important;
} */

/* #map-declarations-tooltip .v-table {
    height: 115px !important;
} */
</style>
